import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { Function } from '@polyai/stream/store/reducers/functions/types';
import type { SpecialFunction } from '@polyai/stream/store/reducers/specialFunctions/types';

interface EventSourcingFunctionTestPanelState {
  targetFn: Function | SpecialFunction | undefined;
  isOpen: boolean;
}

const initialState: EventSourcingFunctionTestPanelState = {
  isOpen: false,
  targetFn: undefined,
};

const eventSourcingFunctionTestPanel = createSlice({
  name: 'eventSourcingFunctionTestPanel',
  initialState,
  reducers: {
    toggleFunctionTestPanel: state => {
      state.isOpen = !state.isOpen;
    },
    setTestTargetFn: (
      state,
      {
        payload: target,
      }: PayloadAction<Function | SpecialFunction | undefined>,
    ) => {
      state.targetFn = target;
    },
  },
});

export const { toggleFunctionTestPanel, setTestTargetFn } =
  eventSourcingFunctionTestPanel.actions;

export default eventSourcingFunctionTestPanel.reducer;
